import React from "react";
import { object, array, string, number } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import { getHeadline } from "../../utils/utils";
import translate from "../../translate";

import "./customStoryCard10.m.css";

const CustomStoryCard10 = ({ story, aspectRatio, imageType, widths, headerType, publisherName }) => {
  const headline = getHeadline(story);

  return (
    <Link href={story.url} styleName="wrapper" className="custom-story-card-10">
      <div styleName="explained-wrapper">
        <div styleName="explained-title">{translate(publisherName, "explained")}</div>
        <div styleName="cards-count-title">{translate(publisherName, "in_5_cards")}</div>
      </div>
      <CardImage
        story={story}
        aspectRatio={aspectRatio}
        imageType={imageType}
        widths={widths}
        eager={true}
        showStoryTypeIcon={false}
      />
      <div styleName="headline-wrapper">
        <Headline text={headline} headerType={headerType} story={story} />
      </div>
    </Link>
  );
};

CustomStoryCard10.defaultProps = {
  aspectRatio: [1, 1],
  imageType: "image1x1",
  headerType: 13,
  widths: [440],
};

CustomStoryCard10.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  widths: array,
  headerType: number,
  publisherName: string,
};

export default CustomStoryCard10;
